module.exports = __webpack_public_path__ + "assets/619855481383b2f4ebb38d76ee08ae3b.png";